import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from 'src/app/appointment/appointment.service';
import { NewCaseComponent } from '../new-case/new-case.component';
import { Router, NavigationExtras } from '@angular/router';
import { TranslateOrgSpecificPipe } from '../pipes/translate-org-specific.pipe';
declare var $: any;
@Component({
  selector: 'app-patient-case',
  templateUrl: './patient-case.component.html',
  styleUrls: ['./patient-case.component.css']
})
export class PatientCaseComponent implements OnInit {
  @Input() public appointmentId;
  @Input() public data;
  @Input() public caseIds;
  btnLabel: string;
  patientCaseList: any[] = [];
  public currentlyClickedCardIndex: number;
  public array: any[] = [];
  savedCaseIds = '';
  modalOption: NgbModalOptions = {};
  constructor(public activeModal: NgbActiveModal
    , private appointmentService: AppointmentService
    , private modalService: NgbModal
    , private router: Router
    , private translateOrgSpecific: TranslateOrgSpecificPipe) { }

  ngOnInit() {

    this.btnLabel = this.data ? this.translateOrgSpecific.transform('CheckIn') : this.translateOrgSpecific.transform('CreateAppointment');
    this.savedCaseIds = this.caseIds ? this.caseIds : '';
    this.getCaseListForPatient();
  }

  getCaseListForPatient(type: string = '') {
    this.appointmentService.getCaseListForPatient().subscribe(
      (data: any) => {
        this.patientCaseList = data;
        let ids = [];
        if (this.savedCaseIds != '') {
          ids = this.savedCaseIds.split(',');
        }
        if (type == 'callback' || ids.length > 0) {
          this.patientCaseList.forEach(element => {
            if (this.array.length > 0) {
              const found = this.array.find(ele => ele.case_id == element.case_id);
              if (found) {
                element.isHighlight = true;
              }
            }
            if (ids.length > 0) {
              const found = ids.find(ele => ele == element.case_id);
              if (found) {
                element.isHighlight = true;
                const casedata = { case_id: Number(found) };
                this.array.push(casedata);
              }
            }
          });
        }
      }
    );
  }

  public setcurrentlyClickedCardIndex(caseData) {
    // select or deselect
    const index = this.patientCaseList.indexOf(caseData);
    this.patientCaseList[index].isHighlight = !this.patientCaseList[index].isHighlight;
    // Return Selected array
    const array_index = this.array.findIndex(d => d.case_id === caseData.case_id);
    const found = this.array.find(ele => ele.case_id == caseData.case_id);
    if (found) {
      this.array.splice(array_index, 1);
    } else {
      this.array.push(caseData);
    }

  }

  // closePopup
  closeModal() {
    this.activeModal.close();
    $('#app-ptnt').css('overflow', 'auto');
    if (this.data && !this.caseIds) {
      this.router.navigate(['/app/dashboard']);
    }

  }

  makeAppointment() {
    const caseId: any[] = [];
    this.array.forEach(element => {
      caseId.push(element.case_id);
    });
    const params: NavigationExtras = {
      queryParams: {
        'case-id': caseId.toString()
      }
    };
    this.activeModal.close(caseId.toString());
    if (!this.appointmentId && !this.data) {
      this.router.navigate(['/app/appointment'], params);
    }

  }
  addReason() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    const dialogRef = this.modalService.open(NewCaseComponent, this.modalOption);
    dialogRef.result.then((result) => {
      if (result != 'Modal Closed') {
        this.savedCaseIds = result;
        this.getCaseListForPatient('callback');
      }
    });
  }

}
